import React, { Component } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import { NavLink } from "react-router-dom";
import "./../styles/navPersonalStyle.css";
import avatarPerson from '../images/avatar-person.svg';
import VentanaColores from "./VentanaColores";
import UserService from "../services/User.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class NavExtra extends Component {
    state = {
        isOpen: false,
        logout: false,
        userData: ''
    }
    fadeOut = () => {
        this.setState({ isOpen: false });
    }
    fadeIn = () => {
        this.setState({ isOpen: true });
    }

    logoutHandler = async () => {
        const response = await UserService.logout();
        if (response.data.message === 'SESSION_CLOSED') {
            this.setState({ logout: true });
            window.location.reload(false);
        } else {
            alert(`Error: ${response.data.message}`);
        }

    }

    async componentDidMount() {
        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({ isLoggedIn: response.data.isLoggedIn, firstTime: false });

        if (response.data.isLoggedIn) {
            const response = await UserService.info();
            this.setState({ userData: response.data.user });
        }

        var btnMenu = document.getElementById("btnMenu");
        var menu = document.getElementById("menu");
        var fondo = document.getElementById("nav");
        if (this.state.isLoggedIn) {
            var closeBTN = document.getElementById("CloseBTN");
        }
        var closeLBL = document.getElementById("CloseLBL");
        var blackScreen = document.getElementById("blackScreen");
        var personOptions = document.getElementById("PersonOptions");
        var showPersonOptions = document.getElementById("Username");

        function closeAndOpenM() {
            fondo.classList.toggle("mostrarFondo");
            menu.classList.toggle("mostrarMenu");
        }
        btnMenu.addEventListener("click", closeAndOpenM);
        if (this.state.isLoggedIn) {
            closeBTN.addEventListener("click", closeAndOpenM);
            closeLBL.addEventListener("click", closeAndOpenM);
        }
        blackScreen.addEventListener("click", closeAndOpenM);

        if (this.state.isLoggedIn) {
            function ShowPO() {
                personOptions.classList.toggle("showOptions");
            }
            showPersonOptions.addEventListener("click", ShowPO);
        }
    }

    render() {
        var userAlter;
        if (this.state.isLoggedIn) {
            userAlter = <React.Fragment>
                <div className="Person">
                    <img alt="avatar" src={avatarPerson} className="UserAvatar" />
                    <button id="Username">{this.state.userData.name}<i class="material-icons-round">keyboard_arrow_down</i></button>
                </div>
                <div id="PersonOptions">
                    <Link to="/user/razones"><i class="material-icons-round">assignment</i>HERRAMIENTAS</Link>
                    <li onClick={this.logoutHandler}><i class="material-icons-round">power_settings_new</i>CERRAR SESIÓN</li>
                </div>
                <div className="TopMenu" style={{ display: "none" }}>
                    <button className="ThemeButton" id="CloseBTN"><i class="material-icons-round">keyboard_arrow_left</i></button>
                    <label id="CloseLBL">ATRÁS</label>
                </div>
            </React.Fragment>
        } else {
            userAlter = <React.Fragment>
                <div className="Person">
                    <div className="disconnectButtons">
                        <Link to="/register" className="btn"><i class="material-icons-round">person_add</i>REGISTRARSE</Link>
                        <Link to="/login" className="btn"><i class="material-icons-round">how_to_reg</i>INICIAR SESIÓN</Link>
                    </div>
                </div>
            </React.Fragment>
        }

        return (
            <div className="NavPersonal">
                <VentanaColores isOpen={this.state.isOpen} closeWindow={this.fadeOut} />
                <header>
                    <button className="btnMenu" id="btnMenu"><i class="material-icons-round">menu</i></button>
                    <div className="btnNecesitoAyuda">
                        <Link className="btn help" to="/window/decision">
                            <i className="material-icons-round prefix">priority_high</i>
                            NECESITO AYUDA
                        </Link>
                    </div>
                    <nav id="nav">
                        <ul id="menu">
                            {userAlter}
                            <div className="List">
                                <li>
                                    <NavLink className="botonLink" activeClassName="activeLink" to="/extra/conozcoAlguien">
                                        <i class="material-icons-round">emoji_people</i>Conozco a alguien
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink className="botonLink" activeClassName="activeLink" to="/extra/profesionales">
                                        <i class="material-icons-round">verified</i>Para profesionales
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink className="botonLink" activeClassName="activeLink" to="/extra/masInfo">
                                        <i class="material-icons-round">add</i>Más información
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink className="botonLink" activeClassName="activeLink" to="/extra/sobreLaApp">
                                        <i class="material-icons-round">help_outlined</i>Sobre la app
                                    </NavLink>
                                </li>
                            </div>
                            <div className="changeColor">
                                <button onClick={() => { this.fadeIn() }} className="btn"><i class="material-icons-round prefix">palette</i>Cambiar color</button>
                            </div>
                            <div className="LogoPart">
                                <Link to="/" className="logo">
                                    <span>Tranqui</span>
                                </Link>
                            </div>
                        </ul>
                        <div id="blackScreen"></div>
                    </nav>
                </header>

                <footer>
                    <ul>
                        {/*<!--Agregar las clase active-->*/}
                        <li><Link to="/user/razones" className="botonLink icon-calendar-check-o"></Link></li>
                        <li><Link to="/user/plan_seguridad" className="botonLink icon-list-ul"></Link></li>
                        <li><Link to="/user/imagenes" className="botonLink icon-picture"></Link></li>
                        <li><Link to="/user/musica" className="botonLink icon-music"></Link></li>
                    </ul>
                </footer>
            </div>
        )
    }
}